import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { UpgradeBottomSlides } from 'ThreeTerminal_mobile_dynamic';
import { h5PageCount } from 'ThreeTerminal_utils';

class BottomSlide extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    clickSendCount = () => {
        h5PageCount([
            {
                behavior: 'action',
                type: 'phtvsole_fx_xd',
                other: {},
            },
        ]);
    };

    render() {
        const { content } = this.props;
        const downloads = {
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1505322057584',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8884',
        };
        const wxLaunchType = content.wxLaunchConfig.wxLaunchType;
        const wxLaunchSwitch = content.wxLaunchConfig.wxLaunchSwitch;
        const slidesConfig = {
            apiConfig: {
                type: 'video',
                from: 'share_relate_foot_video',
                n: 4,
                id: `ucms_${content.base62Id}`,
                apiUrl: 'nine',
            },
            isLogoPic: true,
            insertSlideArr: [
                {
                    downloads,
                    kind: 'inter_fhwslmsp01',
                    wxLaunchType,
                    wxLaunchSwitch,
                    noPrefixKind: 1,
                },
                {
                    downloads,
                    kind: 'inter_fhwslmsp01',
                    wxLaunchType,
                    wxLaunchSwitch,
                    noPrefixKind: 1,
                },
                {
                    downloads,
                    kind: 'inter_fhwslmsp01',
                    wxLaunchType,
                    wxLaunchSwitch,
                    noPrefixKind: 1,
                },
                {
                    downloads,
                    kind: 'inter_fhwslmsp01',
                    wxLaunchType,
                    wxLaunchSwitch,
                    noPrefixKind: 1,
                },
            ],
        };

        return (
            <section className={styles.fixBottom} onClick={this.clickSendCount}>
                <UpgradeBottomSlides noCloseIcon={true} content={slidesConfig} />
            </section>
        );
    }
}

export default errorBoundary(BottomSlide);
